import { render, staticRenderFns } from "./DashboardChartsNoTitle.vue?vue&type=template&id=8369d718&"
import script from "./DashboardChartsNoTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardChartsNoTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8369d718')) {
      api.createRecord('8369d718', component.options)
    } else {
      api.reload('8369d718', component.options)
    }
    module.hot.accept("./DashboardChartsNoTitle.vue?vue&type=template&id=8369d718&", function () {
      api.rerender('8369d718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/DashboardChartsNoTitle.vue"
export default component.exports